import React from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/UI/Hero';
import CRMExplanation from '../components/UI/CRMExplanation';
import Features from '../components/UI/Features';
import SocialProof from '../components/UI/SocialProof';
import HowItWorks from '../components/UI/HowItWorks';
import CRMPricing from '../components/UI/CRMPricing';
import FAQ from '../components/UI/FAQ';
import FinalCTA from '../components/UI/FinalCTA';
import WorldClassTech from '../components/UI/WorldClassTech';
import SEOHead from '../components/UI/SEOHead';
import { ORGANIZATION_SCHEMA, PRODUCT_SCHEMA, FAQ_SCHEMA } from '../data/seoSchemas';

import ROICalculator from '../components/UI/ROICalculator';
import LeadMagnet from '../components/UI/LeadMagnet';

interface HomePageProps {
  theme: 'dark' | 'light';
  activeTab: 'crm' | 'ia';
  setActiveTab: (tab: 'crm' | 'ia') => void;
}

const HomePage: React.FC<HomePageProps> = ({ theme, activeTab, setActiveTab }) => {
  return (
    <motion.div
      key="home"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <SEOHead
        title="Llena tu agenda con los pacientes que ya te escriben"
        description="RurayHUB responde el WhatsApp de tu clínica dental 24/7, agenda citas y envía recordatorios automáticos. Deja de perder pacientes por mensajes sin responder. Agenda una demo de 15 min."
        path="/"
        jsonLd={[ORGANIZATION_SCHEMA, PRODUCT_SCHEMA, FAQ_SCHEMA]}
      />
      <Hero theme={theme} activeTab={activeTab} setActiveTab={setActiveTab} />
      <CRMExplanation />
      <HowItWorks />
      <Features />
      <SocialProof />
      <WorldClassTech />
      <ROICalculator />
      <CRMPricing />
      <FAQ />
      <LeadMagnet />
      <FinalCTA />
    </motion.div>
  );
};

export default HomePage;
